/**
 * Toast 通知组合函数
 */

import { getCurrentInstance } from 'vue'

let toastInstance = null

/**
 * 设置 Toast 实例
 * @param {Object} instance - Toast 组件实例
 */
export function setToastInstance(instance) {
  toastInstance = instance
}

/**
 * 使用 Toast 通知
 * @returns {Object} Toast 方法
 */
export function useToast() {
  // 尝试从当前组件实例获取
  const instance = getCurrentInstance()
  const toast = toastInstance || instance?.appContext.config.globalProperties.$toast

  /**
   * 显示成功提示
   * @param {string} message - 消息内容
   * @param {string} title - 标题（可选）
   * @param {number} duration - 持续时间（可选）
   */
  function success(message, title = '', duration = 3000) {
    if (toast) {
      return toast.showToast({
        type: 'success',
        title,
        message,
        duration
      })
    }
    console.log('✓', title || 'Success', message)
  }

  /**
   * 显示错误提示
   * @param {string} message - 消息内容
   * @param {string} title - 标题（可选）
   * @param {number} duration - 持续时间（可选）
   */
  function error(message, title = '', duration = 4000) {
    if (toast) {
      return toast.showToast({
        type: 'error',
        title,
        message,
        duration
      })
    }
    console.error('✕', title || 'Error', message)
  }

  /**
   * 显示警告提示
   * @param {string} message - 消息内容
   * @param {string} title - 标题（可选）
   * @param {number} duration - 持续时间（可选）
   */
  function warning(message, title = '', duration = 3500) {
    if (toast) {
      return toast.showToast({
        type: 'warning',
        title,
        message,
        duration
      })
    }
    console.warn('⚠', title || 'Warning', message)
  }

  /**
   * 显示信息提示
   * @param {string} message - 消息内容
   * @param {string} title - 标题（可选）
   * @param {number} duration - 持续时间（可选）
   */
  function info(message, title = '', duration = 3000) {
    if (toast) {
      return toast.showToast({
        type: 'info',
        title,
        message,
        duration
      })
    }
    console.info('ℹ', title || 'Info', message)
  }

  return {
    success,
    error,
    warning,
    info
  }
}
